import { capitalize } from 'inflection'
import formatDate from '../../formatDate'

export default {
  methods: {
    capitalize,
    formatDate
  }
}
